import React, { useCallback, useState } from 'react';
import { Container, Box, Snackbar, Typography } from '@mui/material';
import { getContactsStructure } from '../csvImport';
import { updateContacts } from '../firebaseConnection/database';
import Dropzone from '../hooks/Dropzone';

const ContactsImportPage = (): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      try {
        const firebaseData = await getContactsStructure(acceptedFiles[0]);
        delete firebaseData.undefined;
        delete firebaseData[''];
        console.log(firebaseData);
        await updateContacts(firebaseData);

        setMessage('Success!');
        setOpen(true);
      } catch (e) {
        setMessage(`Error: ${e}`);
        setOpen(true);
      }
      setOpen(true);
    }
  }, []);

  return (
    <>
      <Container sx={{ width: `calc(100% - ${240}px)`, ml: `${240}px` }}>
        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
        >
          <Typography variant="h4">Kontakte</Typography>

          <Dropzone drop={csvFile => onDrop(csvFile)} />
        </Box>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message={message}
        />
      </Container>
    </>
  );
};

export default ContactsImportPage;
